{
    "ACDStatusHotKeys_Success_Available": "O agente \"{}\" está disponível",
    "ACDStatusHotKeys_Success_Unavailable": "O agente \"{}\" não está disponível",
    "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Não foi possível definir \"{}\" como disponível.\nEste agente pode já estar disponível ou desconectado.",
    "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Não foi possível definir \"{}\" como indisponível.\nEste agente pode já estar indisponível ou desconectado.",
    "NAME": "ACDStatusHotKeys"
}